import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tv, UserRound } from "lucide-react";
import { toast } from "sonner";
import { PushButton } from "@/components/PushButton";

const NAV = [
  { label: "تابلوی نرخ", href: "#rates" },
  { label: "بازار", href: "#market" },
  { label: "پارسیان", href: "#parsian" },
  { label: "منشور", href: "#manifesto" },
  { label: "تماس", href: "#contact" },
];

const go = (e, href) => {
  e.preventDefault();
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const CoinMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <circle cx="20" cy="20" r="18" fill="none" stroke="#d4af37" strokeWidth="1.6" />
    <circle cx="20" cy="20" r="13.5" fill="none" stroke="#e8c766" strokeWidth="1" />
    <circle cx="20" cy="20" r="13.5" fill="#d4af37" fillOpacity="0.1" />
    <path d="M20 10 L23 17 L30 17 L24.5 21.5 L26.5 29 L20 24.5 L13.5 29 L15.5 21.5 L10 17 L17 17 Z" fill="#e8c766" fillOpacity="0.9" />
  </svg>
);

export const Header = () => {
  const [time, setTime] = useState("");
  useEffect(() => {
    const fmt = new Intl.DateTimeFormat("fa-IR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "Asia/Tehran",
    });
    const tick = () => setTime(fmt.format(new Date()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <header data-testid="site-header" className="glass fixed inset-x-0 top-0 z-50 border-x-0 border-t-0">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-12">
        <Link to="/" data-testid="header-brand" className="flex items-center gap-3">
          <img src="/logo.png" alt="لوگوی سکه کازرانی" className="h-10 w-10 rounded-lg object-contain mix-blend-screen" />
          <span className="leading-tight">
            <span className="block text-base font-bold text-amber-100">سکه کازرانی</span>
            <span className="block text-[11px] text-amber-200/50">مرجع نرخ روز سکه و طلا</span>
          </span>
        </Link>
        <nav className="hidden items-center gap-7 lg:flex">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.href.slice(1)}`}
              onClick={(e) => go(e, n.href)}
              className="text-sm text-stone-300 transition-colors duration-300 hover:text-amber-300"
            >
              {n.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <Link
            to="/tv"
            data-testid="header-tv-link"
            title="حالت تابلوی مغازه"
            aria-label="حالت تابلوی مغازه"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-amber-500/30 text-amber-200 transition-colors duration-300 hover:bg-amber-500/10"
          >
            <Tv className="h-4 w-4" />
          </Link>
          <PushButton />
          <span data-testid="live-time-badge" className="hidden items-center gap-2 rounded-full border border-amber-500/20 px-3 py-1.5 text-xs text-amber-200/80 sm:flex">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
            </span>
            <span dir="ltr">{time}</span>
          </span>
          <button
            type="button"
            data-testid="header-auth-button"
            onClick={() => toast.info("حساب کاربری مشتریان به‌زودی فعال می‌شود")}
            className="flex items-center gap-2 rounded-full border border-amber-500/30 bg-amber-500/10 px-4 py-1.5 text-xs font-medium text-amber-200 transition-colors duration-300 hover:bg-amber-500 hover:text-black"
          >
            <UserRound className="h-3.5 w-3.5" />
            ورود / ثبت‌نام
          </button>
        </div>
      </div>
    </header>
  );
};
